export default __webpack_public_path__ + "static/media/exit_icon.3efe7f02.svg";